export const TOGGLED = 'SERVERMENU_MENU_TOGGLED'
export const OPENED = 'SERVERMENU_MENU_OPENED'
export const CLOSED = 'SERVERMENU_MENU_CLOSED'



// WEBPACK FOOTER //
// ./src/features/ServerMenu/data/open/constants.js